
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/es-mx/ia/recoleccion-de-documentos",
      function () {
        return require("private-next-pages/es-mx/ia/recoleccion-de-documentos/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/es-mx/ia/recoleccion-de-documentos"])
      });
    }
  